export default __webpack_public_path__ + "static/media/menuEditar.173557a3.svg";